// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mrz-container {\n  border-top: 1px solid #f4f5f8;\n  padding-top: 12px;\n  padding-left: 2.2rem;\n  padding-right: 1.05rem;\n  margin-bottom: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
